/* The Polish Glass Journal: scroll reveal, image settle, reading progress, header shadow. */
(function () {
  var post = document.querySelector('.j-post');
  if (post) {
    // Every block in the story eases in; product images settle from a slight zoom.
    Array.prototype.forEach.call(post.children, function (el) { el.classList.add('rv'); });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.rv').forEach(function (el, i) {
    if (el.closest('.j-hero')) el.style.transitionDelay = (i * 0.12) + 's';
    io.observe(el);
  });

  var bar = document.getElementById('j-progress');
  var head = document.getElementById('j-head');
  function onScroll() {
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    if (bar) bar.style.transform = 'scaleX(' + (max > 0 ? h.scrollTop / max : 0) + ')';
    if (head) head.classList.toggle('is-scrolled', h.scrollTop > 10);
  }
  addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
